import { Component } from '@angular/core';

@Component({
  selector: 'app-boundaries',
  template: '<div class="boundaries-container"><h1>Boundaries</h1></div>',
})
export class BoundariesComponent {}
